if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true' || submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification?.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cartNotification) formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      let addConfirmed = false;
      const controller = new AbortController();
      config.signal = controller.signal;
      const timeout = setTimeout(() => controller.abort(), 30000);
      fetch(`${routes.cart_add_url}`, config)
        .then(async (response) => {
          const result = await response.json();
          if (!response.ok && response.status >= 500) throw new Error('Unconfirmed cart response');
          if (result.status || !response.ok) {
            this.handleErrorMessage(result.description || window.cartStrings.error);
            return;
          }
          if (!Number.isSafeInteger(Number(result.id)) || Number(result.id) <= 0) throw new Error('Incomplete cart response');
          addConfirmed = true;
          if (!this.cartNotification) throw new Error('Missing cart notification');
          this.cartNotification.renderContents(result);
        })
        .catch(() => {
          this.handleErrorMessage(addConfirmed ? window.bkrCartStrings.added : window.bkrCartStrings.uncertain, true);
        })
        .finally(() => {
          clearTimeout(timeout);
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false, showCartLink = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.setAttribute('role', 'alert');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        if (showCartLink) {
          const link = document.createElement('a');
          link.href = routes.cart_url;
          link.className = 'bkr-cart-check-link';
          link.textContent = window.bkrCartStrings.check;
          this.errorMessage.append(document.createElement('br'), link);
        }
      }
    }
  });
}
